import '../styles/not-found.css';

export default function NotFount() {
  return (
    <div className="not-found">
      404 Page Not Found      
    </div>
  )
}
